// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain, Handler } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchBeginLoadAccountShipToCollection,
} from "@insite/client-framework/Store/Data/AccountShipTos/Handlers/LoadAccountShipToCollection";
import { CustomerCostCodeDto } from "@insite/client-framework/Types/ApiModels";

export type shipTosCostCodeCollectionData = {
    costCodeCollection: CustomerCostCodeDto[];
};

type HandlerType = typeof DispatchBeginLoadAccountShipToCollection & Handler<shipTosCostCodeCollectionData>;

export const DispatchShipTosCostCodeCollection: HandlerType = (props: any) => {
    props.dispatch({
        type: "xShipTosData/LoadShipTosCostCodeCollection",
        costCodeCollection: props.apiResult.costCodeCollection,
    } as any);
};

addToEndOfChain(chain, DispatchShipTosCostCodeCollection);
